/**
 * 日期工具函数集合
 */

/**
 * 将ISO日期字符串格式化为本地时区的日期显示
 * @param {string} dateString - 日期字符串
 * @returns {string} - 格式化后的日期字符串
 */
export const formatDate = (dateString) => {
  if (!dateString) return '无日期';
  
  try {
    // 打印原始日期字符串，用于调试
    console.log('原始日期字符串:', dateString);
    
    // 确保日期字符串是标准格式
    // 如果是数字数组或对象，尝试转换为ISO字符串
    if (typeof dateString === 'object') {
      console.log('日期是对象格式，尝试转换', dateString);
      // 可能是Java序列化的日期对象，尝试提取年月日等信息
      if (dateString.year !== undefined) {
        // 构建标准日期
        const date = new Date(
          dateString.year, 
          (dateString.monthValue || dateString.month || 1) - 1, 
          dateString.dayOfMonth || dateString.day || 1,
          dateString.hour || 0,
          dateString.minute || 0,
          dateString.second || 0
        );
        console.log('从对象构建的日期:', date);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    }
    
    // 尝试解析日期，服务器返回的应该是带时区的ISO格式字符串
    const date = new Date(dateString);
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      console.error('无效日期:', dateString);
      return '日期无效';
    }
    
    // 如果是1970年，可能是日期格式问题
    if (date.getFullYear() === 1970) {
      console.warn('日期可能无效 (1970):', dateString);
    }
    
    // 直接使用toLocaleDateString，浏览器会自动处理时区转换
    return date.toLocaleString('zh-CN', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('格式化日期出错:', error, '原始数据:', dateString);
    return '日期错误';
  }
};

/**
 * 将ISO日期字符串格式化为本地时区的短日期显示（不含时间）
 * @param {string} dateString - 日期字符串
 * @returns {string} - 格式化后的日期字符串
 */
export const formatShortDate = (dateString) => {
  if (!dateString) return '无日期';
  
  try {
    // 如果是对象格式，尝试转换
    if (typeof dateString === 'object') {
      if (dateString.year !== undefined) {
        // 构建标准日期
        const date = new Date(
          dateString.year, 
          (dateString.monthValue || dateString.month || 1) - 1, 
          dateString.dayOfMonth || dateString.day || 1
        );
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }
    }
    
    // 尝试解析日期
    const date = new Date(dateString);
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      console.error('短日期格式化失败:', dateString);
      return '日期无效';
    }
    
    // 直接使用toLocaleDateString，浏览器会自动处理时区转换
    return date.toLocaleDateString('zh-CN', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric'
    });
  } catch (error) {
    console.error('格式化短日期出错:', error);
    return '日期错误';
  }
};

/**
 * 生成ISO格式的UTC日期字符串，用于发送到服务器
 * @returns {string} - ISO格式的UTC日期字符串
 */
export const getUTCISOString = () => {
  return new Date().toISOString();
}; 